exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".file-item {\n  position: absolute;\n  /*border:1px dashed #fff;*/\n}\n.file-item.selected .file-body {\n  /*border:2px solid rgba(43, 115, 199, 0.36);*/\n  /*background:rgba(43, 115, 199, 0.2);*/\n  background: rgba(0, 134, 255, 0.27);\n}\n.file-item.dragging {\n  opacity: 0.6;\n}\n.file-item .file-body {\n  /*border:2px solid transparent;*/\n  border-radius: 4px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 90px;\n}\n.file-item .file-body .icon {\n  height: 80px;\n  width: 100%;\n  margin: 0 auto;\n  background-size: 64px;\n}\n.file-item .file-body .text {\n  min-height: 20px;\n  line-height: 20px;\n  text-align: center;\n  /*margin:0 -10px; */\n  overflow: hidden;\n  word-wrap: break-word;\n  word-break: break-all;\n  text-overflow: ellipsis;\n  padding-bottom: 5px;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/file-item.vue
 ** module id = 50
 ** module chunks = 0
 **/